import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate, showMessageToastCustom, getUserNameToName, formatData, isNullOrEmpty } from '../../../utils/util';
import { Select, Input, Label, Button, Breadcrumbs } from '../../../components/UI/ComponentsUI';
import ConfigurationService from '../../../services/ConfigurationService';
import { validateInputsRequired, onValueChange } from '../../../utils/handleChangeHooks';

const EquipmentInsert = (props) => {
    const update = props.location?.state?.update;
    const [equipment, setEquipment] = useState(props.location?.state?.update && props.equipment ?
        {
            ...props.equipment,
            fullSector: isNullOrEmpty(props.equipment?.sector)
        } : {});

    useEffect(() => {
        props.getEquipmentTypes(props.user.vision);
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, equipment, setEquipment);
    };

    const redirect = () => {
        props.history.replace('./list');
    };

    const onConfirm = () => {
        if (validateInputsRequired()) {
            equipment.sector = equipment?.fullSector ? "" : equipment.sector
            if (update) {
                props.equipmentUpdate(equipment, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        redirect();
                    }
                });
            } else {
                props.equipmentInsert(equipment, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        redirect();
                    }
                });
            }
        }
    };

    const titleEquipment = { icon: "mdi mdi-clipboard-check-outline", label: translate('menu.configuration', 'configuration') };

    const subtitlesEquipment = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { icon: "build", label: translate('menu.equipment', 'configuration') }];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }];
        return subtitlesItems;
    }

    const onChangeEquipment = (value) => {
        var newValue = value.replace(":", "");
        const modelValue = {};
        Object.assign(modelValue, equipment);
        modelValue.code = newValue;
        setEquipment(modelValue)
    }

    return (
        <div>
            <Breadcrumbs id="equipmentInsert" title={titleEquipment} subtitles={subtitlesEquipment()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form>
                                <div className="row" style={{ marginBottom: '13px' }}>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            required
                                            disabled={update}
                                            label={translate('fields.code', 'equipment')}
                                            id="code"
                                            name="code"
                                            maxLength="20"
                                            type="text"
                                            onChange={(e) => onChangeEquipment(e.target.value)}
                                            value={equipment?.code || ''} />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            disabled={equipment?.fullSector}
                                            required={!equipment?.fullSector}
                                            label={translate('fields.sector', 'equipment')}
                                            id="sector"
                                            name="sector"
                                            maxLength="50"
                                            type="text"
                                            onChange={onChange}
                                            value={equipment?.sector || ''} />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            id="fullSector"
                                            name="fullSector"
                                            type="checkbox"
                                            label={"Todos os setores"}
                                            onChange={onChange}
                                            defaultChecked={equipment?.fullSector}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Select
                                            required
                                            id="equipmentTypeId"
                                            name="equipmentTypeId"
                                            valuefield="id"
                                            display="description"
                                            label={translate('fields.equipmentType', 'equipment')}
                                            placeHolder={translate('choose-one-option', 'general')}
                                            defaultValue={equipment?.equipmentTypeId ? equipment?.equipmentTypeId : ""}
                                            data={props.equipmentTypes ? props.equipmentTypes : []}
                                            change={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Select
                                            required
                                            id="resourceId"
                                            name="resourceId"
                                            valuefield="resourceId"
                                            display="name"
                                            label={translate('fields.resource', 'equipment')}
                                            placeHolder={translate('choose-one-option', 'general')}
                                            defaultValue={equipment?.resourceId ? equipment?.resourceId : ""}
                                            data={props.resources ? props.resources : []}
                                            change={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            id="active"
                                            name="active"
                                            type="checkbox"
                                            label={translate('fields.active', 'equipment')}
                                            onChange={onChange}
                                            defaultChecked={equipment?.active}
                                        />
                                    </div>
                                    {
                                        update &&
                                        <div className="row" style={{ marginBottom: '0px' }}>
                                            <Label label={translate('fields.updateBy', 'equipment')} id="updateBy" name="updateBy" type="text" value={getUserNameToName(props.usersFromElog, equipment?.updateBy)} />
                                            <Label label={translate('fields.updateOn', 'equipment')} id="updateOn" name="updateOn" type="text" value={formatData(equipment?.updateOn)} />
                                        </div>
                                    }
                                </div>
                            </form>
                            <div className="row">
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        equipment: state.configReducer.equipment,
        resources: state.logisticsResourceReducer.list,
        equipmentTypes: state.configReducer.equipmentTypes,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        equipmentInsert: (equipment, callback) => {
            dispatch(ConfigurationService.PostEquipment(equipment, callback));
        },
        equipmentUpdate: (equipment, callback) => {
            dispatch(ConfigurationService.PutEquipment(equipment, callback));
        },
        getEquipmentTypes: (vision, filter) => {
            dispatch(ConfigurationService.getEquipmentTypes(vision, filter));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EquipmentInsert)));
